import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import useFreaksT from './useFreaksT';
import { actionSx, freaksSx as s, tonalSx } from './freaksStyles';

// The Safe (The Crims' bank): banked cash can't be taken in challenges and earns interest each season.
export default function FreaksSafe({ safe, cash, disabled, onDeposit, onWithdraw }) {
  const { t } = useFreaksT();
  return (
    <Box sx={s.card} data-testid="freaks-safe">
      <Box sx={{ ...s.row, gap: 1.5 }}>
        <LockIcon sx={{ fontSize: 32, color: DEFAULT_THEME_COLOR }}/>
        <Box sx={s.grow}>
          <Typography sx={s.title}>{t('theFreaks.safe.title')}</Typography>
          <Typography sx={s.small} data-testid="freaks-safe-balance">
            {t('theFreaks.safe.balance', { cash: safe.cash, capacity: safe.capacity })}
          </Typography>
        </Box>
      </Box>
      <Typography sx={{ ...s.small, ...s.muted, mt: 1 }}>
        {t('theFreaks.safe.hint', {
          fee: Math.round(safe.depositFee * 100),
          interest: Math.round(safe.seasonInterest * 100),
        })}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, mt: 1.25 }}>
        <Button
          data-testid="freaks-safe-deposit"
          disabled={disabled || cash <= 0 || safe.maxDeposit <= 0}
          onClick={onDeposit}
          sx={{ ...actionSx(), flex: 1 }}
        >
          {t('theFreaks.safe.depositAll')}
        </Button>
        <Button
          data-testid="freaks-safe-withdraw"
          disabled={disabled || safe.cash <= 0}
          onClick={onWithdraw}
          sx={{ ...tonalSx, flex: 1 }}
        >
          {t('theFreaks.safe.withdrawAll')}
        </Button>
      </Box>
    </Box>
  );
}
